/**
 * Class describing the values and functions of a Locatable
 * Locatable are trackable items which consistently change position over time
 * 
 * @export {Locatable}
 * @class Locatable
 */

export default class Locatable {
    constructor (id, position) {
        this._id = id;
        this._position = position;
    }

    get Id() {
        return this._id;
    }

    get Position() {
        return this._position;
    }

    /**
     * Performs check on whether passed otherLocatable is equal to this locatable
     * 
     * @param {Locatable} otherLocatable another locatable to compare
     * @memberof Locatable
     */
    isEqual (otherLocatable) {
        return  this._id === otherLocatable.Id &&
                this.Position.X === otherLocatable.Position.X &&
                this.Position.Y === otherLocatable.Position.Y &&
                this.Position.Z === otherLocatable.Position.Z;
    }
}



// WEBPACK FOOTER //
// ./src/classes/Locatable.js